import {
    SWITCH_DELIVERY_TAB,
} from '../../actions/types';

const INITIAL_STATE = {
    activeTab: 0
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SWITCH_DELIVERY_TAB:
            return { ...state, activeTab: action.payload };
        default:
            return state;
    }
};
